module.exports = __webpack_public_path__ + "img/logo-1x.57e4aeff.png";